import React, { useRef, useState } from "react";
import { UrlApi } from "../../services/apirest";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { logEventos } from "../../services/services";

function DialogCancelarViaje(props) {
  const { cancelar, datosRow, onClose } = props;

  const [procesando, setProcesando] = useState(false);
  const [confirmacion, setConfirmacion] = useState("");
  const [error, setError] = useState("");
  const [avisos, setAvisos] = useState([]);
  const procesandoRef = useRef(false);

  const cerrar = () => {
    if (procesandoRef.current) return;
    if (onClose) onClose();
  };

  const cancelarViaje = async (confirmar = false) => {
    if (procesandoRef.current) return;

    procesandoRef.current = true;
    setProcesando(true);
    setError("");

    let cerrarAlTerminar = false;

    try {
      const res = await fetch(
        UrlApi + "/viajes_abastecimiento/" + datosRow.id_viaje + "/cancelar",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ confirmar }),
        }
      );

      const data = await res.json().catch(() => null);

      if (res.status === 409 && data?.codigo === "CONFIRMACION_REQUERIDA") {
        setConfirmacion(data.mensaje);
        return;
      }

      if (!res.ok || !data?.ok) {
        setError(data?.mensaje || "No se pudo cancelar el viaje.");
        return;
      }

      logEventos(
        "Guardar viaje cancelado",
        "Viajes",
        "Se canceló el viaje " + datosRow.id_viaje,
        localStorage.getItem("user")
      );

      if (Array.isArray(data.avisos) && data.avisos.length > 0) {
        setConfirmacion("");
        setAvisos(data.avisos);
      } else {
        cerrarAlTerminar = true;
      }
    } catch (err) {
      console.error(err);
      setError("No se pudo conectar con el servidor. Intentá nuevamente.");
    } finally {
      procesandoRef.current = false;
      setProcesando(false);
    }

    if (cerrarAlTerminar && onClose) onClose();
  };

  const mostrarAvisos = avisos.length > 0;

  return (
    <Dialog open={cancelar} onClose={cerrar} fullWidth maxWidth="sm">
      <DialogTitle>
        {mostrarAvisos ? "Viaje cancelado" : "Confirmar cancelación"}
      </DialogTitle>

      <DialogContent>
        {mostrarAvisos ? (
          avisos.map((aviso) => (
            <Alert severity="warning" sx={{ mb: 1 }} key={aviso}>
              {aviso}
            </Alert>
          ))
        ) : (
          <>
            <Typography sx={{ mb: 2 }}>
              ¿Desea cancelar el viaje N° {datosRow.id_viaje}?
            </Typography>

            {confirmacion ? (
              <Alert severity="warning" sx={{ mb: 1 }}>
                {confirmacion}
              </Alert>
            ) : null}

            {error ? (
              <Alert severity="error" sx={{ mb: 1 }}>
                {error}
              </Alert>
            ) : null}
          </>
        )}
      </DialogContent>

      <DialogActions>
        {mostrarAvisos ? (
          <Button variant="contained" onClick={cerrar}>
            Entendido
          </Button>
        ) : (
          <>
            <Button onClick={cerrar} disabled={procesando}>
              No
            </Button>
            <Button
              variant="contained"
              color={confirmacion ? "warning" : "error"}
              disabled={procesando}
              onClick={() => cancelarViaje(Boolean(confirmacion))}
            >
              {procesando
                ? "Cancelando..."
                : confirmacion
                  ? "Cancelar de todos modos"
                  : "Sí, cancelar"}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default DialogCancelarViaje;